import { useEffect, useState } from "react"
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { getcountryConfigurationMaster, getCountryMobileCodes, getDesignationMaster, getEmployeeRangeMaster } from "../../service/masterService"
import { useDispatch, useSelector } from "react-redux"
import { onboardFormActions } from "../../store/onboardFormState"
import DatePicker from "react-datepicker"
import 'react-datepicker/dist/react-datepicker.css'
import { numbersOnly, validatePhoneNumber } from "../../helpers/numbers"
import { alphabetsOnly, alphanumericOnly, alphanumericWithSpaceOnly } from "../../helpers/string"
import { sortEmployeeRanges } from "../../helpers/array";
import { countryData } from "../../utils/constants";

export const BusinessDetailsForm = ({ isAllValidated, setIsAllPhoneValid , isEmailsUnique, setIsEmailsUnique }) => {
    const dispatch = useDispatch()
    const [desginations, setDesignations] = useState([])
    const [employeeRange, setEmployeRange] = useState([])
    const [establishmentYearDropDown, setEstablishmentYearDropDown] = useState([])

    
    
	 const [countryConfiguration,setcountryConfiguration]=useState([]);
    const [countryMobileCodes, setCountryMobileCodes] = useState([])
    const [isPrimaryPhoneNumberValid, setIsPrimaryPhoneNumberValid] = useState(false)
    const [isOfficeNumberValid, setIsOfficeNumberValid] = useState(false)
    const [isMobileNumberValid, setIsMobileNumberValid] = useState(false)
    const formState = useSelector(state => state.onboardForm)

    const setDesignationData = async () => {
        const res = await getDesignationMaster()
        if (res?.status == 200) {
            setDesignations(res.data.items)
        }
    }

    const setEmployeeRangeData = async () => {
        const res = await getEmployeeRangeMaster()
        if (res?.status == 200) {
            setEmployeRange(sortEmployeeRanges(res.data.items))
        }
    }

    const setMobileCodeDropDown = async () => {
        const res = await getCountryMobileCodes()
        if (res.status == 200) {
            setCountryMobileCodes(res.data)
        }
    }

    const updateFieldValue = (key, value) => {
        dispatch(onboardFormActions.updateValue({ key, value }))
    }

    const renderYearContent = (year) => {
        const title = year
        return <span className="p-3" title={title}>{year}</span>;
    };

    const countryList = countryData?.sort((a, b) => {
        if (a.name.common < b.name.common) return -1;
        if (a.name.common > b.name.common) return 1;
        return 0;
      });



      useEffect(()=>
        {
            setcountryConfigurationData();
            // updateValue("country",countryList[0].name.common)
            updateFieldValue("country", alphabetsOnly(countryList[0].name.common))
            
    
        },[])

        useEffect(() => {
    if (formState.emailAddress && formState.primaryContactEmail) {
        if (formState.emailAddress === formState.primaryContactEmail) {
            setIsEmailsUnique(true);
        } else {
            setIsEmailsUnique(false);
        }
    }
}, [formState.emailAddress, formState.primaryContactEmail]);


        const setcountryConfigurationData = async () => {
            const res = await getcountryConfigurationMaster()
            if (res?.status == 200) {
                setcountryConfiguration(res.data.items)
            }
        }
        
    useEffect(() => {
        setDesignationData()
        setEmployeeRangeData()
        let currentYear = new Date().getUTCFullYear()
        let years = []
        for (let i = 1990; i <= currentYear; i++) {
            years.push(i)
        }
        setEstablishmentYearDropDown(years)
        setMobileCodeDropDown()
    }, [])

    useEffect(() => {
        if (isMobileNumberValid && isOfficeNumberValid && isPrimaryPhoneNumberValid) {
            setIsAllPhoneValid(true)
        } else {
            setIsAllPhoneValid(false)
        }
    }, [isMobileNumberValid, isOfficeNumberValid, isPrimaryPhoneNumberValid])
    return (
        <div>
            <div className="row form-default mt-4">
                <div className="col-12 col-md-3">
                    <div className="form-group">
                        <label data-end="*">Trade license no.</label>
                        <input
                            aria-valuenow={"Trade license no."}
                            id="tradeLicence"
                            type="text"
                            maxLength={50}
                            className="form-control mandatory"
                            placeholder="Enter trade license no. here"
                            value={formState.tradeLicence}
                            onChange={(e) => updateFieldValue("tradeLicence", alphanumericOnly(e.target.value))}
                        />
                    </div>
                </div>
                <div className="col-12 col-md-3">
                    <div className="form-group">
                        <label data-end="*">VAT registration no.</label>
                        <input
                            aria-valuenow={"VAT registration no."}
                            id="vateRegistration"
                            type="text"
                            maxLength={50}
                            className="form-control mandatory"
                            placeholder="Enter VAT registration here"
                            value={formState.vatRegistration}
                            onChange={(e) => updateFieldValue("vatRegistration", alphanumericOnly(e.target.value))}
                        />
                    </div>
                </div>
            </div>
            <div className="row form-default">
                <div className="col-12 col-md-3">
                    <div className="form-group">
                        <label data-end="*">Name of the applicant firm</label>
                        <input
                            aria-valuenow={"Name of the applicant firm"}
                            type="text"
                            maxLength={50}
                            className="form-control mandatory"
                            placeholder="Enter name of the applicant firm here"
                            value={formState.nameOfApplicantFirm}
                            onChange={(e) => updateFieldValue("nameOfApplicantFirm", alphanumericWithSpaceOnly(e.target.value))}
                        />
                    </div>
                </div>
                <div className="col-12 col-md-3">
                    <div className="form-group">
                        <label data-end="*">Year of establishment</label>
                        <DatePicker
                            selected={formState.yearOfEstablishment ? new Date().setFullYear(formState.yearOfEstablishment) : new Date()}
                            wrapperClassName="full-width form-control"
                            renderYearContent={renderYearContent}
                            className="form-control mandatory"
                            showYearPicker
                            dateFormat="yyyy"
                            value={formState.yearOfEstablishment ? new Date().setFullYear(formState.yearOfEstablishment) : new Date()}
                            maxDate={new Date()}
                            onChange={(e) => updateFieldValue("yearOfEstablishment", e.getFullYear())}
                        />
                        {/* <select defaultValue={"Select"} className="form-control"
                            onChange={(e) => updateFieldValue("yearOfEstablishment", e.target.value)}
                        >
                            <option disabled>Select</option>
                            {establishmentYearDropDown.map((value) => {
                                return (
                                    <option key={value}>{value}</option>
                                )
                            })}
                        </select> */}
                    </div>
                </div>
            </div>
            <div className="row form-default">
                <div className="col-12 col-md-3">
                    <div className="form-group">
                        <label data-end="*">Number of employees</label>
                        <select defaultValue={"Select"} className="form-control mandatory"
                            aria-valuenow={"Number of employees"}
                            onChange={(e) => updateFieldValue("numberOfEmployees", e.target.value)}
                        >
                            <option disabled>Select</option>
                            {employeeRange?.map((d) => {
                                return (
                                    <option key={d.id}>{d.name}</option>
                                )
                            })}
                        </select>
                    </div>
                </div>
                <div className="col-12 col-md-3">
                    <div className="form-group">
                        <label >Turnover last year (in AED)</label>
                        <input
                            aria-valuenow={"Turnover last year (in AED)"}
                            type="text"
                            maxLength={9}
                            className="form-control"
                            value={formState.lastYearTurnover}
                            placeholder="Enter last year turnover here"
                            onChange={(e) => updateFieldValue("lastYearTurnover", numbersOnly(e.target.value))}
                        />
                    </div>
                </div>
            </div>
 
            <p className="mb-0 font-20">Business Contact Details</p>
            <div className="row form-default mt-4">
                <div className="col-12 col-md-3">
                    <div className="form-group">
                        <label data-end="*">Office telephone</label>
                     
                        <PhoneInput aria-valuenow={"Office telephone"} enableSearch={true} disableSearchIcon={true} inputclassName="font-10" dropdownclassName="font-10"
                            onChange={(value) => updateFieldValue("officeTelephone", value)}
                            countryCodeEditable={false}
                            country={'ae'}
                            isValid={(phone, country) => {
                                const isValid = validatePhoneNumber(phone, country)
                                setIsOfficeNumberValid(isValid)
                                return true
                            }
                            }
 
                        // value={}
                        />
                        {!isOfficeNumberValid ? <span className="validation-error">Please enter valid number.</span> : ""}
                    </div>
                </div>
                <div className="col-12 col-md-3">
                    <div className="form-group">
                        <label data-end="*">Mobile no.</label>
                        {/* <div className="d-flex">
                            <input
                                aria-valuenow={"Phone Code"}
                                type="text"
                                style={{ width: "50px" }}
                                className="form-control"
                                disabled
                                value={"+91"}
                            />
                            <input
                                aria-valuenow={"Mobile no."}
                                type="text"
                                maxLength={10}
                                className="form-control mandatory"
                                placeholder="Enter mobile number here"
                                value={formState.mobileNumber}
                                onChange={(e) => updateFieldValue("mobileNumber", numbersOnly(e.target.value))}
                            />
                        </div> */}
                        <PhoneInput aria-valuenow={"Mobile no."} enableSearch={true} disableSearchIcon={true} inputclassName="font-10" dropdownclassName="font-10"
                            onChange={(value) => updateFieldValue("mobileNumber", value)}
                            countryCodeEditable={false}
                            country={'ae'}
                            isValid={(phone, country) => {
                                const isValid = validatePhoneNumber(phone, country)
                                setIsMobileNumberValid(isValid)
                                return true
                            }
                            }
                        // value={}
                        />
                        {!isMobileNumberValid ? <span className="validation-error">Please enter valid number.</span> : ""}
                    </div>
                </div>
            </div>
            <div className="row form-default">
                <div className="col-12 col-md-3">
                    <div className="form-group">
                        <label data-end="*">Email address</label>
                        <input
                            aria-valuenow={"Email address"}
                            type="email"
                            maxLength={45}
                            className="form-control mandatory"
                            placeholder="Enter email address here"
                            onChange={(e) => updateFieldValue("emailAddress", e.target.value)}
                        />
                    </div>
                </div>
            </div>
 
            <p className="mb-0 font-20">Address Details</p>
            <div className="row form-default mt-4">
                <div className="col-12 col-md-3">
                    <div className="form-group ">
                        <label data-end="*">Address</label>
                        <textarea
                            aria-valuenow={"Address"}
                            type="text"
                            maxLength={100}
                            className="form-control mandatory"
                            placeholder="Enter address here"
                            onChange={(e) => updateFieldValue("address", e.target.value)}
                        />
                    </div>
                </div>
                <div className="col-12 col-md-3">
                    <div className="form-group">
                        <label data-end="*">City</label>
                        <input
                            aria-valuenow={"City"}
                            maxLength={50}
                            type="text"
                            className="form-control mandatory"
                            placeholder="Enter area here"
                            onChange={(e) => updateFieldValue("area", e.target.value)}
                        />
                    </div>
                </div>
            </div>
            <div className="row form-default">
                <div className="col-12 col-md-3">
                   
 
 
 
 
 
                    <div className="form-group">
                        <label data-end="*">Country</label>
                        <select aria-valuenow={"Country"} defaultValue={"Select"} className="form-control mandatory" onChange={(e) => updateFieldValue("city", alphabetsOnly(e.target.value))}>
                            <option disabled>Select</option>
                            {countryList?.map((d,idx) => {
                               
                                return (
                                    <option key={idx}>{d.name.common}</option>
                                )
                            })}
                        </select>
                    </div>
                </div>
            </div>
            <p className="mb-0 font-20">Primary Contact Details</p>
            <div className="row form-default mt-4">
                <div className="col-12 col-md-3">
                    <div className="form-group ">
                        <label data-end="*">Designation</label>
                        <select defaultValue={"Select"} className="form-control mandatory"
                            aria-valuenow={"Designation"}
                            onChange={(e) => updateFieldValue("primaryContactDesignation", e.target.value)}
                        >
                            <option disabled>Select</option>
                            {desginations?.map((d) => {
                                return (
                                    <option key={d.id}>{d.name}</option>
                                )
                            })}
                        </select>
                    </div>
                </div>
                <div className="col-12 col-md-3">
                    <div className="form-group">
                        <label data-end="*">Name</label>
                        <input
                            aria-valuenow={"Name"}
                            type="text"
                            maxLength={30}
                            value={formState.primaryContactName}
                            className="form-control mandatory"
                            placeholder="Enter contact person's name"
                            onChange={(e) => updateFieldValue("primaryContactName", alphabetsOnly(e.target.value))}
                        />
                    </div>
                </div>
            </div>
            <div className="row form-default">
                <div className="col-12 col-md-3">
                    <div className="form-group mb-100">
                        <label data-end="*">Primary email address</label>
                        <input
                            aria-valuenow={"Primary email address"}
                            type="email"
                            maxLength={45}
                            className="form-control mandatory"
                            placeholder="Enter email address here"
                            onChange={(e) => updateFieldValue("primaryContactEmail", e.target.value)}
                        />
                        <p className="align-center font-10 opacity-60 font-10 mt-5">The primary email address will be used for all communication purposes.</p>
                    </div>
 
 
                </div>
                <div className="col-12 col-md-3">
                    <div className="form-group">
 
                        <label data-end="*">Phone number</label>
                     
                        <PhoneInput aria-valuenow={"Phone number"} enableSearch={true} disableSearchIcon={true} inputclassName="font-10" dropdownclassName="font-10"
                            onChange={(value) => updateFieldValue("primaryContactPhone", value)}
                            countryCodeEditable={false}
                            country={'ae'}
                            isValid={(phone, country) => {
                                const isValid = validatePhoneNumber(phone, country)
                                setIsPrimaryPhoneNumberValid(isValid)
                                return true
                            }
                            }
                        />
                        {!isPrimaryPhoneNumberValid ? <span className="validation-error">Please enter valid number.</span> : ""}
 
                    </div>
                </div>
            </div>
        </div>
    )
}